import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { hasCookieConsentDecision, saveCookieConsent } from '../../utils/cookie-consent.util';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent implements OnInit {
  visible = false;

  ngOnInit(): void {
    this.visible = !hasCookieConsentDecision();
  }

  acceptAll(): void {
    saveCookieConsent('all');
    this.visible = false;
  }

  acceptEssentialOnly(): void {
    saveCookieConsent('essential');
    this.visible = false;
  }
}
